import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeReportAdminZones } from '../../../admin/actions/reportActions';
import CartListReport from '../../../components/CardListReport/CartListReport';
import { Translate } from '../../../language';
import Button from '../../../utils/components/Button/Button';
import style from "./ZoneRoomAdmin.module.css";
const AdminReportsZone = ({ isLoadingListReports, reports, reportsMembers, reportsPost, tab, setTab, subTab, setSubTab }) => {
    const dispatch = useDispatch()

    return (
        <div className={style.content_right_container}>
            <div className={style.btn_container_reports}>

                <Button text='Publicaciones' active={tab ==="zonepost"} onClick={() => setTab("zonepost")} />
                <Button text='Miembros' active={tab ==="zonemember"} onClick={() => setTab("zonemember")} />
            </div>
            {
                tab ==='zonemember' ? (
                    <div className={style.report_container}>
                        {
                            !isLoadingListReports && reportsMembers.map(report => {
                                let src = null
                                let name = null
                                const member = report.zoneMemberID
                                switch (member.memberType) {
                                    case "user":
                                        name = member.userId.name
                                        src = member.userId.picture && member.userId.picture.url && member.userId.picture.url.small
                                        break;
                                    case "franchise":
                                        name = member.franchiseId.socialReason
                                        src = member.franchiseId.picture && member.franchiseId.picture.url && member.franchiseId.picture.url.small
                                        break;
                                    case "representative":
                                        name = member.representativeId.userID.name
                                        src = member.representativeId.userID.picture &&
                                            member.representativeId.userID.picture.url &&
                                            member.representativeId.userID.picture.url.small
                                        break;
                                    case "warehouse":
                                        name = member.userId.name
                                        src = member.warehouseId.profileId.picture &&
                                            member.warehouseId.profileId.picture.url &&
                                            member.warehouseId.profileId.picture.url.small
                                        break;

                                    default:
                                        break;
                                }
                                return (
                                    <CartListReport
                                    textOne={name}
                                    textTwo={name}
                                    options={[
                                        {
                                            text: Translate("accept", "es"),
                                            onClick: (e) => {
                                                e.stopPropagation();
                                                //     history.push("/PersonalInfo");

                                                dispatch(changeReportAdminZones({
                                                    reportID: report._id,
                                                    status: 2
                                                }))
                                            }
                                        },
                                        {
                                            text: Translate("reject", "es"),
                                            onClick: (e) => {
                                                e.stopPropagation();
                                                dispatch(changeReportAdminZones({
                                                    reportID: report._id,
                                                    status: 1
                                                }))
                                            }
                                        }
                                    ]}
                                        type={report.reportedType}
                                        descriptions={report.descriptions}
                                        typeOfReportsIDS={report.typeOfReportsIDS}
                                        picture={src}
                                        key={report._id}
                                    />
                                )
                            })
                        }
                    </div>
                ) :
                    (
                        <div>
                            <div className={style.btn_container_sub_reports}>

                                <Button text='Publicaciones' active={subTab ==="zonepost"} onClick={() => setSubTab("zonepost")} />
                                <Button text='Comentarios' active={subTab ==="comment"} onClick={() => setSubTab("comment")} />
                                <Button text='Respuesta de Comentarios' active={subTab ==="commentresponse"} onClick={() => setSubTab("commentresponse")} />
                            </div>
                            <div className={style.report_container}>

                                {
                                    !isLoadingListReports && reports.map(report => (
                                        <CartListReport
                                            descriptions={report.descriptions}
                                            typeOfReportsIDS={report.typeOfReportsIDS}
                                            options={[
                                                {
                                                    text: Translate("accept", "es"),
                                                    onClick: (e) => {
                                                        e.stopPropagation();
                                                        //     history.push("/PersonalInfo");

                                                        dispatch(changeReportAdminZones({
                                                            reportID: report._id,
                                                            status: 2
                                                        }))
                                                    }
                                                },
                                                {
                                                    text: Translate("reject", "es"),
                                                    onClick: (e) => {
                                                        e.stopPropagation();
                                                        dispatch(changeReportAdminZones({
                                                            reportID: report._id,
                                                            status: 1
                                                        }))
                                                    }
                                                }
                                            ]}
                                            type={report.reportedType}
                                            post={report.zonePostID}
                                            comment={report.commentID}

                                            //  picture={report.reportedUserID.picture && report.reportedUserID.picture.url ? report.reportedUserID.picture.url.origin : report.reportedUserID.picture}
                                            key={report._id}
                                            // textOne={report.reportedUserID.name}
                                            textTwo={`Reportado por ${report.typeOfReportsIDS.length > 0 ? report.typeOfReportsIDS[0].description : report.descriptions[0].message}`}

                                        />
                                    ))
                                }
                            </div>
                        </div>
                    )
            }
        </div>
    )
};

export default AdminReportsZone;
